import { render, staticRenderFns } from "./TestSubscriptionExtended.vue?vue&type=template&id=5bdb13bb&"
import script from "./TestSubscriptionExtended.vue?vue&type=script&lang=js&"
export * from "./TestSubscriptionExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports